import autocomplete from 'autocomplete.js';
import algoliasearch from 'algoliasearch';
import template from 'lodash/template'

var client = algoliasearch('F8FUMZ1QIP', 'a143680e60362c99a33c0b56b89b211c');
var searchIndex = client.initIndex('search');

document.addEventListener("DOMContentLoaded", function() {
    autocomplete('.js-search', {
        hint: false,
        debug: true,
        keyboardShortcuts: ['s', '/']
    }, [{
        source: autocomplete.sources.hits(searchIndex, {hitsPerPage: 5}),
        displayKey: 'name',
        templates: {
            footer: '#search-footer',
            empty: '#search-empty',
            suggestion: function (suggestion) {
                var source = document.getElementById('search-suggestion').innerHTML;

                return template(source)({item: suggestion, highlighted: suggestion._highlightResult});
            }
        }
    }]).on('autocomplete:selected', function (event, suggestion, dataset, context) {
        // https://github.com/algolia/autocomplete.js#how-can-i-control-click-on-results-and-have-them-open-in-a-new-tab
        // Do nothing on click, as the browser will already do it
        if (context.selectionMethod === 'click') {
            return;
        }

        // Change the page, for example, on other events
        window.location.href = suggestion.url;
    });
});
